import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import CustomLoader from '../common/CustomLoader';
import { CustomDataMappingForm } from './custom-mapping/CustomDataMappingForm';
import { loadExternalApis } from '../external-api/redux/loadExternalApis';
import { REST_API } from 'drapcode-constant';
import { checkCustomComponentPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class CustomDataMappingEditPage extends Component {
  static propTypes = {
    customComponent: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { activeTab: 'customDataMapping', dataMappingId: '' };

  componentDidMount = () => {
    const { match, actions } = this.props;
    const { projectId, version, dataMappingId } = match.params;
    actions.loadProjectDetailCustomComponent({ projectId, version });
    actions.loadCustomComponentConfigs({ projectId, version });
    actions.loadCustomDataMapping({ projectId });
    loadExternalApis({ projectId, version, externalApiType: REST_API });

    if (dataMappingId) this.setState({ dataMappingId });
  };
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.customComponent;
    if (prevProps.customComponent.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }
  componentMenuToggle = (activeTab) => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    this.setState({ activeTab });
    history.push(`/custom-component/${version}/v/${projectId}/${activeTab}`);
  };

  appSettingToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  aiModelToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  render() {
    const isAllowed = checkCustomComponentPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent containerClassName="customComponent">
          <PermissionDenied message="Custom Component" />
        </CommonPageComponent>
      );
    }
    const { match, customComponent, home, history, externalapi, actions } = this.props;
    const { projectDetail, customDataMappings, loadProjectDetailCustomComponentPending } =
      customComponent;
    const { dataMappingId, activeTab } = this.state;
    const { collections } = home;
    const { projectId, version } = match.params;
    const { externalApis } = externalapi;

    if (loadProjectDetailCustomComponentPending || !projectDetail) {
      return (
        <CommonPageComponent parentClassName="">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
              <CustomLoader
                loading={loadProjectDetailCustomComponentPending}
                size="20px"
                color="#303453"
              />
            </div>
          </div>
        </CommonPageComponent>
      );
    }
    const customDataMapping = customDataMappings
      ? customDataMappings.find((mapping) => mapping.uuid === dataMappingId)
      : '';
    return (
      <CommonPageComponent containerClassName="customComponent">
        <AppSettingsNav
          activeTab={activeTab}
          projectDetail={projectDetail}
          advanceAppConstantToogle={this.appSettingToggle}
          customComponentMenuToogle={this.componentMenuToggle}
          CustomCSSJSMenuToogle={this.appSettingToggle}
          SnapshotMenuToogle={this.appSettingToggle}
          AIModelMenuToggle={this.aiModelToggle}
        />
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <CustomDataMappingForm
            projectId={projectId}
            version={version}
            collections={collections}
            externalApis={externalApis}
            projectDetail={projectDetail}
            dataMappingId={dataMappingId ? dataMappingId : ''}
            customDataMapping={customDataMapping}
            history={history}
            actions={actions}
          />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    customComponent: state.customComponent,
    home: state.home,
    externalapi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomDataMappingEditPage);
